import {map, prop, omit } from 'ramda';
import { getRenamedAd } from '../utils/renameAd';

const SearchPage = data => {
  const ads = map(prop('content'), data.adv || {});

  const header_banner_panel = getRenamedAd('header-banner', 'header_banner_panel', ads)
  const lower_banner_panel = getRenamedAd('lower-banner', 'lower_banner_panel', ads)

  return {
    ...data.story,
    content: {
      ...data.story.content,
      ads: {
        ...omit(['header-banner', 'lower-banner'], ads),
        header_banner_panel,
        lower_banner_panel
      }
    }
  }
}

export { SearchPage };
